"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.displayDate = exports.videoCountString = exports.projectCountString = void 0;

var _moment = _interopRequireDefault(require("moment"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var projectCountString = function projectCountString(count) {
  return "".concat(count, " ").concat(count === 1 ? 'Project' : 'Projects');
};

exports.projectCountString = projectCountString;

var videoCountString = function videoCountString(count) {
  return "".concat(count, " ").concat(count === 1 ? 'Video' : 'Videos');
};

exports.videoCountString = videoCountString;

var displayDate = function displayDate(date, format) {
  return (0, _moment.default)(date, ['x', 'YYYY-MM-DDTHH:mm:ss.sssZ']).format(format);
};

exports.displayDate = displayDate;